import { render } from "./BloqueUnoPrincipal.vue?vue&type=template&id=0e3097ca"
import script from "./BloqueUnoPrincipal.vue?vue&type=script&lang=js"
export * from "./BloqueUnoPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__